import AppBar from './components/AppBar';
import Hero from './components/Hero';
import Services from './components/Services';
import Media from './components/Media';
import Footer from './components/Footer';
import Team from './components/Team';
import Testimonial from './components/Testimonial';
import Contact from './components/Contact';

import './styles/Common.css';
import Partners from './components/Partners';
import Brands from './components/Brands';

function App() {
  return (
    <>
      <AppBar />
      <Hero id="home" />
      <Services id="services"/>
      <Brands/>
      {/* <Team id="team"/> */}
      <Media id="news"/>
      {/* <Testimonial id="testimonial"/> */}
      <Partners id="partner"/>
      <Contact id="contact"/>
      <Footer/>
    </>
  );
}

export default App;
